import { render, staticRenderFns } from "./Institute.vue?vue&type=template&id=52c0fc56&scoped=true"
import script from "./Institute.vue?vue&type=script&lang=js"
export * from "./Institute.vue?vue&type=script&lang=js"
import style0 from "./Institute.vue?vue&type=style&index=0&id=52c0fc56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c0fc56",
  null
  
)

export default component.exports